/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
const localeToLanguageMap: Record<string, string> = {
  ar: 'Arabic',
  en: 'English',
  es: 'Spanish',
}

/**
 * Converts a given locale into the corresponding language.
 * If no matching language is found for the provided locale, returns 'Unknown'.
 *
 * @param locale - the locale code to be converted into language
 */
const convertLocaleToLanguage = (locale: string): string => {
  return localeToLanguageMap[locale] || 'Unknown'
}

export { convertLocaleToLanguage }
